module.exports = __webpack_public_path__ + "img/enterpriseTitle.a0bdd28a.jpg";